import { render } from "./Nombre_resultat_afficher.vue?vue&type=template&id=fa4ad646"
import script from "./Nombre_resultat_afficher.vue?vue&type=script&lang=js"
export * from "./Nombre_resultat_afficher.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Sebastien.Ducharme/condamnation-datepicker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__